import React from 'react';
import classNames from 'classnames';
import Filters from './detail-components/filters';

const FilterPanel = ({
    units,
    allUnits,
    totalUnitsInAreas,
    numberOfUnits,
    filters,
    onApplyFilters,
    onSetDataForSelected,
    filterModalIsOpen,
    onCloseModal,
    unitsVisible,
    type
}) => {
    if (!allUnits || allUnits.length === 0) return null;

    return (
        <aside className={classNames({
            'filter-panel': true,
            'filter-panel--is-open': filterModalIsOpen
        })}>
            <Filters 
                units={units}
                allUnits={allUnits}
                totalUnitsInAreas={totalUnitsInAreas}
                numberOfUnits={numberOfUnits}
                filters={filters}
                applyFilters={onApplyFilters}
                setDataForSelected={onSetDataForSelected}
                filterModalIsOpen={filterModalIsOpen}
                closeModal={onCloseModal}
                type={type}
                unitsVisible={unitsVisible}
            />
        </aside>
    );
};

export default FilterPanel; 